import { Eleicao } from './../models/eleicao.model';
import { environment } from '../../environments/environment';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EleitorDTO } from '../models/eleitorDTO.model';
import { resolve } from 'dns';
import { rejects } from 'assert';
import { NewEleitorDTO } from '../models/newEleitorDTO.model';


@Injectable({
  providedIn: 'root'
})
export class EleicaoService {

  eleicao: Eleicao;
  configHeader: { headers: { Authorization: any; }; };
  private logoEleicaoSubject = new Subject<string>();
  private _logoEleicao = null as string;
  set logoEleicao(logoEleicao: string) {
    this._logoEleicao = logoEleicao;
    this.logoEleicaoSubject.next(logoEleicao);
  }
  get logoEleicao() {
    return this._logoEleicao;
  }
  get logoEleicao$() {
    return this.logoEleicaoSubject.asObservable();
  }
  
  constructor(
    private http: HttpClient
  ) { }

  public getById(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/eleicoes/${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  public getCandidatosByIdEleicao(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/candidatos/${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })

  }

  public getCargosByIdEleicao(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/eleicoes/${id}/cargos`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }


  public getCargosByIdEleicao2(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get(`${environment.url_api}/cargos/byEleicaoAndPlano/${id}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public salvarDadosNovaEleicao(tokenParam: any, eleicao: Eleicao) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': tokenParam } },
        this.http.post(`${environment.url_api}/eleicoes`, eleicao, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    });
  }

  public editarInfoEleicao(token, eleicao: Eleicao, idEleicao: Number) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.put(`${environment.url_api}/eleicoes/${idEleicao}`, eleicao, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        }, err => {
          reject(err.error.message);
        }  
      )
    })
  }

  public findAllEleitoresByEleicaoId(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get<EleitorDTO[]>(`${environment.url_api}/eleicoes/${id}/eleitores`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }
  
  public enviarEmailsLoginEleitor(id: number, eleitores: EleitorDTO[], token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      
        this.http.post(`${environment.url_api}/eleicoes/${id}/enviaEmails`, eleitores ,this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public findAllEleitoresByEleicaoIdPage(eleicaoId: number,linesPerPage:number,page: number, login: string, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },

        this.http.get<EleitorDTO[]>(`${environment.url_api}/eleicoes/eleitores/page?eleicaoId=${eleicaoId}&linesPerPage=${linesPerPage}&page=${page}&login=${login}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }
        )
    })
  }

  public getLogoByRotaEleicao(rota) {
    return this.http.get(`${environment.url_api}/eleicoes/logo?rotaEleicao=${rota}`, { responseType: "text" });
  }

  public verifyIntegracao(rota) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.url_api}/eleicoes/verifyIntegration?rotaEleicao=${rota}`).subscribe(
        payload=>{
          resolve(payload)
        }, err =>{
          reject(err.error)
        }
      )
    });
  }

  public recuperacaoSenhaEleitorEmail(param: String) {
    return new Promise((resolve, reject)=> {
      this.http.post(`${environment.url_api}/eleicoes/emailRedefinirSenhaEleitor`, param).subscribe(
        payload=>{
          resolve(payload)
        }, err =>{
          reject(err.error.message)
        }
      )
    });
  }

  public getEleicaoByRota(rota){
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.url_api}/eleicoes/by-rota?rotaEleicao=${rota}`).subscribe(
        payload=>{
          resolve(payload)
        }, err =>{
          reject(err.error)
        }
      )
    });
  }

}
